<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import Screen from "../../../../components/screen";
import i18n from "../../../../i18n";
import { accountbindingService } from "../../../../services/settingservice/accountbinding.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Account Type Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Search
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Account Type template",
      breadCrumb: {},

      data: {},
      account: {},
      valueBooking: 0,
      valuePayment: 0,
      valuePenalty: 0,
      valueDiscount: 0,
      valueInterest: 0
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);
    }
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      accountbindingService.getOne(id)
        .then(response => {

          this.breadCrumb = {
            text: i18n.t('setting.account-binding.text'),
            active: true,
          };
          
          this.fetchingStats = true;

          if(id != 0) {
            this.data = response.data;
            this.valueBooking = this.data.booking_account_id;
            this.valuePayment = this.data.payment_account_id;
            this.valuePenalty = this.data.penalty_account_id;
            this.valueDiscount = this.data.discount_account_id;
            this.valueInterest = this.data.interest_account_id;
          }

          this.loadingSettings(response.setting);
        });
    },

    loadingSettings: function(setting) {
      this.account = { data: setting.accounts };
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let obj = {
        booking_account_id: this.valueBooking,
        payment_account_id: this.valuePayment,
        penalty_account_id: this.valuePenalty,
        discount_account_id: this.valueDiscount,
        interest_account_id: this.valueInterest
      };

      accountbindingService.update(this.$route.params.id, obj).then(response => {
        if(response.status == 200) {
          
          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message'),
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: i18n.t('general.success.yes'),
            cancelButtonText: i18n.t('general.success.no')
          }).then(result => {
            if (!result.value) {
              this.tryingToSubmit = false;

              this.$router.push(this.$route.query.redirectFrom || {
                name: "setting-accountbinding",
                params: {id: 1}
              });
            } 
          });

        }
      });
      

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div>
      <PageHeader :items="[{
        text: $t('setting.account-binding.text'),
        href: '/setting/accountbinding/1',
      }, this.breadCrumb]" :title="$t('setting.account-binding.text')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                  <h4 class="card-title">{{$t('booking.text')}}</h4>
              </div>
              <div class="row">
                
                <div class="col-md-3">
                  <Search 
                    :id="`booking_account_id`"
                    v-model="valueBooking"
                    :list="account"
                    :label="'booking.text'"  />
                </div>
                
              </div>

              <div class="row" style="margin-top: 20px;">
                  <h4 class="card-title">{{$t('payment.text')}}</h4>
              </div>
              <div class="row">
                
                <div class="col-md-3">
                  <Search 
                    :id="`payment_account_id`"
                    v-model="valuePayment"
                    :list="account"
                    :label="'payment.text'"  />
                </div>
                <div class="col-md-3">
                  <Search 
                    :id="`penalty_account_id`"
                    v-model="valuePenalty"
                    :list="account"
                    :label="'booking.text'"  />
                </div>
                <div class="col-md-3">
                   <Search 
                    :id="`discount_account_id`"
                    v-model="valueDiscount"
                    :list="account"
                    :label="'general.discount'"  />
                </div>
                <div class="col-md-3">
                   <Search 
                    :id="`interest_account_id`"
                    v-model="valueInterest"
                    :list="account"
                    :label="'general.interest'"  />
                </div>
              </div>


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>